<template>
  <div class="about">
    <h1>This is an about page</h1>
    
     <v-col
        class="mb-5"
        cols="122"
      >
        <h2 class="headline font-weight-bold mb-3">
          API Endpoint
        </h2>

        <v-row justify="center">
          <v-text-field type="url" class="mx-6 justify-center"  v-model="apiurl"/>
          <v-btn @click="persist">Save</v-btn>
        </v-row>
      </v-col>


  </div>
</template>
<script>
  export default {
    name: 'About',
    data: () => ({
    apiurl: process.env.VUE_APP_API_ENDPOINT,
    }),
    mounted() {
      if (localStorage.apiurl) {
        this.apiurl = localStorage.apiurl;
      }
      this.$api.defaults.baseURL = this.apiurl;
    },
    methods: {
      persist() {
        localStorage.apiurl = this.apiurl;
        this.$api.defaults.baseURL = this.apiurl;
      }
    }
}
</script>
